module.exports = __webpack_public_path__ + "static/media/dksk_full_logo.12e0f819.png";